<template>
    <div>
        <svg xmlns="http://www.w3.org/2000/svg" :width="widthIs" :height="heightIs" viewBox="0 0 20 20" fill="none">
            <path
                d="M10.9375 5.3125C10.9375 4.79473 10.5178 4.375 10 4.375C9.48223 4.375 9.0625 4.79473 9.0625 5.3125V11.5625C9.0625 12.0803 9.48223 12.5 10 12.5C10.5178 12.5 10.9375 12.0803 10.9375 11.5625V5.3125Z"
                :fill="fillColor" />
            <path
                d="M10.9375 14.6875C10.9375 14.1697 10.5178 13.75 10 13.75C9.48223 13.75 9.0625 14.1697 9.0625 14.6875C9.0625 15.2053 9.48223 15.625 10 15.625C10.5178 15.625 10.9375 15.2053 10.9375 14.6875Z"
                :fill="fillColor" />
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM18.125 10C18.125 14.4873 14.4873 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10C1.875 5.51269 5.51269 1.875 10 1.875C14.4873 1.875 18.125 5.51269 18.125 10Z"
                :fill="fillColor" />
        </svg>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    props: {
        fillColor: {
            type: String,
            default: 'white'
        },
        widthIs: {
            type: String,
            default: '20'
        },
        heightIs: {
            type: String,
            default: '20'
        }
    },
}
</script>
<style scoped>
svg{
    min-width: 1rem;
}
</style>